module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_500-Red-0d402a0092202f8c79caed74318be4f6.png";